import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isArray } from '@jd/jmtd-tools/es/is';
export var ON_TH_CLICK = Symbol('onThClick');
export var TH_DECORATOR = Symbol('thDecorator');
export var TH_TOOLTIP = Symbol('thTooltip');
export var TH_PROPS = Symbol('thProps');
export var RAW = Symbol('raw');
export var ORIGIN = Symbol('origin');
export var TD_DECORATOR = Symbol('tdDecorator');
export var CUSTOM_ROW = Symbol('customRow');
export var EMPTY_ROW = Symbol('empty-row');
export var CUSTOM_CELL = '__CUSTOM_CELL__';
export var defaultColumnRender = function defaultColumnRender(x) {
  return x;
};
export function getAffixAlign(value) {
  return value === true ? 'left' : value;
}
export function hasChildren(children) {
  return children && isArray(children) && children.length;
}
export function mapColumns(columns, mapper) {
  var result = [];
  var index = 0;

  function map(from, to) {
    from.forEach(function (column) {
      var children = column.children;

      if (hasChildren(children)) {
        var childrenTo = [];
        to.push(_objectSpread(_objectSpread({}, column), {}, {
          children: childrenTo
        }));
        map(children, childrenTo);
      } else {
        to.push(mapper(column, index++));
      }
    });
  }

  map(columns, result);
  return result;
}
export function flat(columns) {
  var result = [];

  function map(list) {
    list.forEach(function (column) {
      var children = column.children;

      if (hasChildren(children)) {
        map(children);
      } else {
        result.push(column);
      }
    });
  }

  map(columns);
  return result;
}